import { BarcodeScannerService } from '../../../../utils/barcode-scanner/barcode-scanner.service';
import { Component, Injector, Input, OnDestroy, OnInit, Output, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { OnDemandDriverModel } from '../../on-demand-drivers.model';
import { IMyDateModel, IMyOptions } from 'mydatepicker';
import { EventEmitter } from '@angular/common/src/facade/async';
import { OnDemandDriversService } from '../../on-demand-drivers.service';
import { CompaniesService } from '../../../companies/companies.service';
import { RolesService } from '../../../roles/roles.service';
import { constant } from '../../../../app.constants';
import * as moment from 'moment';
import { Ssn } from 'app/core/interfaces/ssn-interface';
import { ModalActiveService } from 'app/core/services/modalActive.service';
import { Subscription } from 'rxjs/Subscription';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { IOpenReport } from 'app/core/interfaces/IGenericReport.interface';
import { GenericReportingService } from 'app/core/services/genericReporting.service';
import { T2CardComponent } from 'app/trip2-theme/components/t2-card/t2-card.component';
import { NgForm } from '@angular/forms';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { ToastrAlertHelper } from '../../../../core/helpers/toastr-alert-helper-service';
import { SsnService } from 'app/utils/ssn-module/ssn.service';
import { DriverApplicationStatusEnum } from 'app/core/enums/driver.enum';
import { BarcodeScannerEnum } from 'app/utils/barcode-scanner/enum/barcode-scanner.enum';
import { IScannedDriverLicense } from 'app/utils/barcode-scanner/interfaces/barcode-scanner.interface';
import { UploadImgService } from 'app/pages/A2-utils/upload-img/upload-img.service';
import { UploadsService } from 'app/pages/A2-utils/uploads.service';
import { IResponseSuccessData } from '../../../../core/interfaces/response.interface';
import { SweetAlertResult } from 'sweetalert2';
import { OnDemandApplicationDriverStatusEnum } from '../../../../core/enums/driver.enum';
import { ReportsIdEnum } from 'app/core/enums/reportsId.enum';
import { IStatusDriverOnDemand } from 'app/core/interfaces/driver.interface';
import { finalize, take } from 'rxjs/operators';
import { ParentModule } from 'app/pages/A2-utils/ParentClass/parent-module';
import { isValidEmail } from 'app/utils/helpers';

enum OnDemandSignatureState {
  Available = 1,
  Disabled = 2,
  Missing = 3
}

@Component({
  selector: 'app-on-demand-drivers-personal-info',
  templateUrl: './personal-info.component.html',
  styleUrls: ['./personal-info.component.scss']
})
export class PersonalInfoComponent extends ParentModule implements OnInit, OnChanges, OnDestroy {

  get hasProfilePhoto(): boolean {
    return !!this.data && !!this.data.profilephoto;
  }

  get hasDriverLicensePhoto(): boolean {
    return !!this.driverLicensePhotoUrl;
  }

  get showNoDriverLicense(): boolean {
    return !this.hasDriverLicensePhoto;
  }

  get driverLicensePhotoUrl(): string {
    return this.data
      ? this.data.driverlicencephoto || this.data.driverlicensephoto || ''
      : '';
  }

  get canViewSignature(): boolean {
    return this.validHasSignature === OnDemandSignatureState.Available && this.showSignature;
  }

  currentDate: any;
  isCheck: boolean;
  dateVal = true;
  public previous;

  private startDateVal: any;
  private followUpDateVal: any;
  private isFolowUpDate = false;
  addedonFormated: string;
  data: OnDemandDriverModel = new OnDemandDriverModel();
  private companies: any;
  private status: any[];
  protected rejReasonList: any[];
  private referrals: any[];
  private devices: any[] = [{
    deviceid: 1,
    description: 'IOS'
  }, {
    deviceid: 2,
    description: 'Android'
  }];
  private disabledInputs = true;
  private disabledClass = 'setDisableClass setReadOnlyClass';
  private thePattern = '';
  private myDatePickerOptions: IMyOptions = {
    dateFormat: 'mm-dd-yyyy',
    editableDateField: true
  };
  private missingFields = '\n';
  public maskPhone = constant.MASKS.PHONES.DEFAULT_ONDEMAND;
  public maskDate = constant.MASKS.DATES.DDMMYYYY;
  public MASK_SSN = constant.MASK_SSN_DRIVER;
  driverStatus: number;
  previousStatus: number;
  approvedStatus: IStatusDriverOnDemand[] = [];

  availableDriverSchedule: boolean;
  @Input() selected: number;
  @Input() isFormExpanded = false;
  @Output() notify: EventEmitter < boolean > = new EventEmitter < boolean > ();
  @Output() cancel: EventEmitter < boolean > = new EventEmitter < boolean > ();
  @Output() activeChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() actionsComp: any;
  @Input() actionsComponent: { showSsn: boolean, updateSsn: boolean, verifyDriverLicense: boolean, scanDriverLicense: boolean };
  @ViewChild('driverSchedule') driverSchedule: T2CardComponent;
  @ViewChild('modalForm') modalForm: NgForm;
  @ViewChild('modalChngPsswd') private modalChngPsswd: T2CardComponent;
  @ViewChild('driverLicenseScanner') private driverLicenseScanner: T2CardComponent;
  @ViewChild('noteModal') noteModal: T2CardComponent;
  @ViewChild('imagePOP') imagePOP: T2CardComponent;
  @ViewChild('imagePOP2') imagePOP2: T2CardComponent;
  @ViewChild('imagePOPSignature') imagePOPSignature: T2CardComponent;

  note: string;

  protected subscriptions: Subscription[] = [];
  showSignature = true;
  urlSignature: SafeUrl = '';
  currentUser = null;
  emitSsnOndemand: EventEmitter<Ssn> = new EventEmitter<Ssn>();
  disbaledBtnSave: boolean;
  constructor(
    protected service: OnDemandDriversService,
    protected companyService: CompaniesService,
    protected roleActionService: RolesService,
    private modalActiveService: ModalActiveService,
    private genericReportService: GenericReportingService,
    private sanitizer: DomSanitizer,
    private sweetAlertHelper: SweetAlertHelper,
    private toastrAlertHelper: ToastrAlertHelper,
    private ssnService: SsnService,
    private barcodeScannerService: BarcodeScannerService,
    private uploadImageService: UploadImgService,
    private uploadService: UploadsService,
    protected Inject: Injector,
  ) {
    super('ondemand-drivers', Inject);
    this.getAllCompanies();
    this.getAllStatus();
    this.getAllReferrals();
  }

  /**
   * @name ngOnInit
   * @description
   */
  ngOnInit(): void {
    const currentDay = Date.now();
    this.currentDate = moment(currentDay).format('YYYY-MM-DD');

    if (this.selected) {
      this.getDataDriver();
    }
    this.searchDriverInformation();
    this.data.isactive = true;

    this.subscriptions.push(
      this.actionsList$.subscribe({
        next: (actionNames) => {
          this.service.setActionNames(actionNames);
          if (actionNames && actionNames.length && actionNames.includes('Update')) {
            this.disabledInputs = false;
            this.disabledClass = '';
          }
        }
      }),
      this.service.disabledBtnSchedule$.subscribe((subs) => {
        if (subs) {
          this.statusDriverScheduleBtn();
        }
      })
    );

    this.subscribeToBarcodeScannerSubject();
    this.subscribeToUploadImageSubject();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const selectedChange = changes['selected'];

    if (
      selectedChange &&
      !selectedChange.isFirstChange() &&
      selectedChange.currentValue &&
      selectedChange.currentValue !== selectedChange.previousValue
    ) {
      this.searchDriverInformation();
    }
  }

  private searchDriverInformation(): void {
    if (this.selected !== 0) {
      this.service.getDriverByID(this.selected).subscribe({
        next: (data) => {
          this.emitSsnOndemand.emit(data);
          this.setData(data);
          this.driverStatus = data.driverstatusid;
          this.previousStatus = data.applicationstatusid;
          this.startDateVal = this.datePickerVal(data.startdate);
          this.followUpDateVal = this.datePickerVal(data.followupdate);
          data.isfollowup
            ? (this.isFolowUpDate = true)
            : (this.isFolowUpDate = false);
          if (data.addedon) {
            this.formatedDate(data.addedon);
          }
          this.showSignature = data.hassignature;
          this.urlSignature = data.signaturephoto;
          /*   if (data.isactive && typeof this.startDateVal === "undefined") {
              this.disableBtn(true)
            } */
          this.getRejectedStatus();
          this.statusDriverScheduleBtn();
        }, error: (er) => {
          this.sweetAlertHelper.captureException(er);
        }
      });
    }
  }

  private subscribeToBarcodeScannerSubject(): void {
    this.subscriptions.push(
      this.barcodeScannerService.barcodeScannerAction$.subscribe({
        next: (actionState) => {
          if (!actionState) { return; }
          const { action, data } = actionState;

          switch (action) {
            case BarcodeScannerEnum.SendBarcodePdf417Data:
              this.setLicenseDateByBarcodeScanner(data as IScannedDriverLicense);
              this.driverLicenseScanner.close();
              break;
            case BarcodeScannerEnum.SendBarcodeQrCodeData:
              this.driverLicenseScanner.close();
              break;
          }
        }
      })
    );
  }

  private subscribeToUploadImageSubject(): void {
      this.subscriptions.push(
        this.uploadImageService.imageFile$.subscribe({
          next: (image) => {
            if (!image) { return; }
            this.callServiceToExtractLicenseNumberFromImage(image);
            this.driverLicenseScanner.close();
          }
        })
      );
    }

  callServiceToExtractLicenseNumberFromImage(image: File) {
    this._loading.show();
    const url = constant.DRIVER.DRIVER_LICENSE.EXTRACT_LICENSE_NUMBER_FROM_IMAGE;
    this.uploadService.makeSimplyFileRequest<IScannedDriverLicense>(url, image)
      .finally(() => this._loading.hiden())
      .subscribe({
        next: (res) => {
          if (typeof res !== 'object') { return; }
          this.setLicenseDateByBarcodeScanner(res);
        },
        error: (err) => this.sweetAlertHelper.captureException(err)
      });
  }

  private setLicenseDateByBarcodeScanner(data: IScannedDriverLicense): void {
    const { licensenumber, licensestate, licenseexpirationdate } = data;

    this.data.driverlicense = licensenumber;
    this.data.licensestate = licensestate;
    this.data.licenseexpiry = licenseexpirationdate;
  }

  getDataDriver() {
    this.service.getDriverByID(this.selected).subscribe({
      next: (data) => {
        this.manageDataDriver(data);
      },
      error: (err) => {
        this.sweetAlertHelper.captureException(err);
      },
    });
  }

  private manageDataDriver(data: any): void {
    this.emitSsnOndemand.emit(data);
    this.setData(data);
    this.driverStatus = data.driverstatusid;
    this.startDateVal = this.datePickerVal(data.startdate);
    this.followUpDateVal = this.datePickerVal(data.followupdate);
    this.isFolowUpDate = !!data.isfollowup;
    data.addedon = this.formatedDate(data.addedon);
    this.showSignature = data.hassignature;
    this.urlSignature = data.signaturephoto;
    this.getRejectedStatus();
    this.statusDriverScheduleBtn();
  }

  statusDriverScheduleBtn() {
    if (this.data.userprofileid) {
      this.service.getAvailableDriverSchedule(this.data.userprofileid).subscribe(res => this.availableDriverSchedule = res);
    }
  }

  /**
   * @name checVal
   * @description get envent if true o false
   * @param event
   */
  /* checVal(event:any) {
    this.isCheck = event.currentTarget.checked;
    if (this.isCheck && !this.data.startdate) {
      this.startDateVal = this.datePickerVal(this.currentDate)
    }else {
      if (!this.data.startdate) {
        this.startDateVal = "";
        this.disableBtn(false);
    }
  }
}
 */
  /**
   * @name datePickerVal
   * @description
   * @param ptr
   */
  private datePickerVal(ptr) {
    if (ptr !== undefined) {
      const date = ptr.split('-');
      const dateModel = {
        date: {
          // tslint:disable-next-line:radix
          year: parseInt(date[0]),
          // tslint:disable-next-line:radix
          month: parseInt(date[1]),
          // tslint:disable-next-line:radix
          day: parseInt(date[2])
        }
      };
      return dateModel;
    }
  }

  /**
   * @name onDateChanged
   * @description
   * @param event
   */
  public onDateChanged(event: IMyDateModel) {
    this.data.startdate = event.formatted;
  }

  disableBtn(inactiv: boolean) {
    this.previous = <HTMLInputElement>document.getElementById('btnId');
    this.previous.disabled = inactiv;
  }

  /**
   * @name
   * @description
   * @param event
   */
  public onFollowUpDateChanged(event: IMyDateModel) {
    this.data.followupdate = event.formatted;
  }

  /**
   * @name changeFollowUp
   * @description
   * @param event
   */
  public changeFollowUp(event) {
    if (event) {
      this.isFolowUpDate = true;
    } else {
      this.isFolowUpDate = false;
      this.followUpDateVal = null;
      this.data.followupdate = null;
    }
  }

  /**
   * @name setData
   * @description
   * @param data
   */
  setData(data) {
    this.data = data;
    this.data.licenseexpiry = data.licenseexpiryformatted;
    this.data.dob = data.dobformattedstandard;
    data.middleinitial ? this.data.middleinitial = data.middleinitial.trim() : this.data.middleinitial = '';
    this.data.ddcsenddate = data.ddcsenddateformatted;
    this.data.cprsenddate = data.cprsenddateformatted;
  }

  /**
   * @name getAllCompanies
   * @description
   */
  getAllCompanies() {
    this.companyService
    .getOnDemandCompanies()
    .subscribe(
      data => this.companies = data
    );
  }

  /**
   * @name sendNotify
   * @description
   * @param data
   */
  sendNotify(data: any) {
    this.notify.emit(data);
  }

  /**
   * @name modifySsnDriver
   * @description Modifica el SSN para que lleve solo numeros y letras
   * @param ssn = valor del ssn a modificar
   */
  modifySsnDriver(ssn: string) {
    if (ssn) {
      this.data.ssn = ssn.replace('-', '');
      if (this.data.ssn.includes('-')) {
        this.modifySsnDriver(this.data.ssn);
      }
    }
  }


  saveActionStatus() {
    if (this.changeStatusFromSuspendedToApproved()) {
      this.sweetAlertHelper
        .createCustomAlert({
          title: 'Status Change',
          text: 'Are you sure you want to change the status from suspended to approved?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
        })
        .then((result) => {
          if ( result && result.value ) {
            this.noteModal.open();
          }
        });
    } else {
      this.saveAction();
    }
  }

  onNoteModalEvents(event) {
    if (!event.isOpen) {
      this.note = '';
    }
  }

  saveActionWithValidation() {
    if ( this.isNoteEmpty && this.data.applicationstatusid ) {
      this.toastrAlertHelper.error('Please enter a note before sending.');
      return;
    }

    this.saveAction();
  }

  /**
   * @name saveAction
   * @description
   */
  saveAction(): void {
    if (this.data.emailaddress && !isValidEmail(this.data.emailaddress)) {
      this.toastrAlertHelper.error(
        'Please enter a valid email address',
        'Error',
      );
      return;
    }
    this.disbaledBtnSave = true;
    this.data.rejectionstatusid = this.data.rejectionstatusid === undefined ? null :
      this.data.rejectionstatusid;

    this.modifySsnDriver(this.data.ssn);
    if (this.selected === 0) {
      this.data.hassignature = false;
      this.service
        .postData(this.data)
        .finally(() => this.ssnService.disabledInput.emit(true))
        .subscribe(
          res => {
            this.sendNotify(res);
            this.disbaledBtnSave = false;
          },
          er => {
            this.disbaledBtnSave = false;
            this.sendNotify(er.error);
          }
        );
    } else {
     this.updateDriverData();
    }
  }

  private updateDriverData(verifyLicense = false): void {
    this.data.hassignature = this.showSignature;
    this.data.note = this.note;
    this._loading.show();
    this.service
      .putData(this.data)
      .pipe(
        finalize(() => {
          this._loading.hiden();
          this.ssnService.disabledInput.emit(true);
          this.noteModal.close();
        })
      )
      .subscribe({
        next: (res: any) => {
          if (verifyLicense) {
            this.verifyDriverLicense();
          }

          const statusChanged = this.changeStatusFromSuspendedToApproved();
          const notifyPayload = statusChanged
            ? {
                success: true,
                title: res.message,
                message:
                'Status has been successfully changed from suspended to approved. '
                + 'The password was updated and sent to the driver by email',
              }
            : res;

          this.sendNotify(notifyPayload);
          this.disbaledBtnSave = false;
          this.searchDriverInformation();
        },
        error: (err) => {
          this.disbaledBtnSave = false;
          this.sendNotify(err);
        },
      });
  }


  /**
   * @name cancelCreateEdit
   * @description
   */
  cancelCreateEdit() {
    this.cancel.emit(true);
  }

  /**
   * @name loadLocation
   * @description
   * @param resp
   */
  loadLocation(resp: any) {
    this.data.streetaddress = resp.street_number + ' ' + resp.route;
    this.data.city = resp.locality;
    this.data.state = resp.administrative_area_level_1;
    this.data.zip = resp.postal_code;
    this.data.longitude = resp.longitude;
    this.data.latitude = resp.latitude;
  }

  /**
   * @name getAllStatus
   * @description
   */
  public getAllStatus() {
    this.service
    .getAllStatus()
    .subscribe(
      (data) => {
        this.status = data;
        this.calculateApprovedStatuses();
      }
    );
  }

  /**
   * @name getAllReferrals
   * @description
   */
  public getAllReferrals() {
    this.service.getReferrals().subscribe(
      data => this.referrals = data
    );
  }

  /**
   * @name onBlurDate
   * @description
   */
  onBlurDate() {
    this.thePattern = '^((0?[1-9]|1[012])[- -.](0?[1-9]|[12][0-9]|3[01])[- -.](19|20)?[0-9]{2})*$';
  }


  formatedDate(addedon: Date) {
    if (addedon!) {
      return '';
    }
    const date = new Date(addedon);
    this.addedonFormated = moment(date).format('MM-DD-YYYY');
  }

  get driverStatusOnline(): string {
    if (this.driverStatus === 11) {
      document.getElementById('onLine').style.color = 'green';
      return 'Driver Is Online';
    } else if (this.driverStatus === 12) {
      document.getElementById('onLine').style.color = 'red';
      return 'Driver Is Offline';
    }
  }

  getRejectedStatus(event?: any): void {
    switch (this.data.applicationstatusid) {
      case 34:
        this.service.getRejectedReason()
        .subscribe({
          next: (data: any) => { this.rejReasonList = data; },
          error: (er: any) => {}
        });
        break;
      default:
        break;
    }
  }

  activeOnDemandDriver(isActive: boolean): void {
    this.data.isactive = isActive;
    if (!isActive) {
      this.modalActiveService.openModalActive('Reason for inactivation');
      this.modalActiveService.callBack$
        .pipe(take(1))
        .subscribe({
          next: (res: { value: any, cancel: boolean }) => {
            if (res.cancel) {
              this.data.isactive = true;
              this.data.inactivateReason = '';
              this.activeChanged.emit(true);
            } else {
              if (this.selected !== 0) {
                this.data.inactivateReason = res.value;
                this.saveAction();
                this.activeChanged.emit(false);
              } else {
                this.data.inactivateReason = '';
                this.activeChanged.emit(false);
              }
            }
          },
          error: (er: any) => this.toastrAlertHelper.error(er.error, 'Error')
        });
    } else {
      if (this.selected !== 0) {
        this.data.inactivateReason = '';
        this.saveAction();
      }
      this.activeChanged.emit(true);
    }
  }

  setActiveFromHeader(isActive: boolean): void {
    this.data.isactive = isActive;
    this.activeOnDemandDriver(isActive);
  }

  sanitize(url: string) {
    if (url) {
      return this.sanitizer.bypassSecurityTrustUrl(url);
    }
  }

  toggleSignature(event): void {
    if (event.type === 'change') {
      if (!this.urlSignature || this.urlSignature === null) {
        this.sweetAlertHelper.createCustomAlert({
          type: 'warning',
          title: `The driver does not have a registered signature`,
          showConfirmButton: true,
        }).then(() => {
          this.showSignature = false;
        });
      }
    }
  }

  get validHasSignature(): OnDemandSignatureState {
    if (!this.urlSignature) {
      return OnDemandSignatureState.Missing;
    }

    return this.showSignature
      ? OnDemandSignatureState.Available
      : OnDemandSignatureState.Disabled;
  }

  openPhotoPreview(event: MouseEvent): void {
    if (this.hasProfilePhoto && !this.isFormExpanded && this.imagePOP) {
      this.imagePOP.open(event);
    }
  }

  openDriverLicensePreview(event: MouseEvent): void {
    if (this.hasDriverLicensePhoto && this.imagePOP2) {
      this.imagePOP2.open(event);
    }
  }

  openSignaturePreview(event: MouseEvent): void {
    if (this.canViewSignature && this.imagePOPSignature) {
      this.imagePOPSignature.open(event);
    }
  }

  openReport(): void {
    const modelGenericReport: IOpenReport = {
      numberReport: ReportsIdEnum.driver_termns_and_conditions,
      bodyRequestReport: {
        parameters: { Driver: `${this.selected}` }
      }
    };
    this.genericReportService.openGenericReport(modelGenericReport);
  }

  googleEmiter(event) {
    if (event) {
      this.data.streetaddress = event.streetaddress;
      this.data.city = event.city;
      this.data.state = event.state;
      this.data.zip = event.zip;
      this.data.latitude = event.latitude;
      this.data.longitude = event.longitude;
    }
  }

  onValidateSsn() {
    const ssn = this.modalForm.value.ssn;
    if (ssn && (ssn.replace(/\D/g, '').length !== 9)) {
      this.modalForm.controls['ssn'].setErrors({ 'incorrect': true });
    }
  }

  private verifyDriverLicense(): void {
    this.service.verifyDriverLicense(this.data.userprofileid)
      .pipe(finalize(() => this._loading.hiden()))
      .subscribe({
        next: (response: IResponseSuccessData<boolean>) => {
          const { data: isValid, message: licenceStatus }: IResponseSuccessData<boolean> = response;
          this.sweetAlertHelper.createCustomAlert({
            title: 'Driver License Verification',
            text: licenceStatus,
            type: isValid ? 'success' : 'error',
            showConfirmButton: true
          }).then(() => {
            this.data.islicensevalid = isValid;
            if (!isValid) {
              this.data.applicationstatusid = OnDemandApplicationDriverStatusEnum.Suspended;
            }
          });
          this.searchDriverInformation();
        },
        error: (err) => this.sweetAlertHelper.captureException(err)
      });
  }

  showVerifyDriverLicenseModalConfirmation(): void {
    this.sweetAlertHelper.createCustomAlert({
      type: 'warning',
      title: 'Driver License Verification',
      text: `This action will verify the status of the driver's license with an external service (Fees may apply)
             If the license is invalid, the driver’s status will be set to Suspended automatically.
             Do you want to continue?`,
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Continue',
      cancelButtonText: 'Cancel'
    }).then((result: SweetAlertResult): void => {
      const { value: isConfirmed } = result;
      if (!isConfirmed) { return; }
      this.updateDriverLicense();
    });
  }

  private updateDriverLicense(): void {
    this.updateDriverData(true);
  }

  private calculateApprovedStatuses() {
    this.approvedStatus = this.status
      ? this.status.filter(
          (stat) =>
            stat.driverstatusid === OnDemandApplicationDriverStatusEnum.Approved
        )
      : [];
  }

  get emailErrorVisibility(): string {
    return this.isEmailInvalid ? 'visible' : 'hidden';
  }

  get isEmailInvalid(): boolean {
    const ctrl = this.modalForm && this.modalForm.controls['email'];
    return (
      ctrl &&
      ctrl.errors &&
      ctrl.errors['pattern'] &&
      (ctrl.dirty || ctrl.touched)
    );
  }

  get btnDisabledSave(): boolean {
    return !this.modalForm.valid || this.disbaledBtnSave;
  }

  get showReactivateMobileAccount(): boolean {
    const isActive = this.data.isactive;
    const applicationStatusId = this.data.applicationstatusid;
    return (
      !isActive &&
      applicationStatusId === DriverApplicationStatusEnum.Rejected &&
      !!this.selected
    );
  }

  warningBeforeReactivatingMobileAccount(): void {
    this.sweetAlertHelper.createCustomAlert({
      type: 'warning',
      title: 'Are you sure you want to reactivate your account?',
      text: 'This action will allow the driver to use the mobile application again. '
        + 'Additionally, a new password will be generated for the driver and sent to their email address.',
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Yes, Reactivate',
      cancelButtonText: 'No, Cancel'
    }).then((result) => {
      if (result && result.value) {
        this.reactivateMobileAccount();
      }
    });
  }

  private reactivateMobileAccount() {
    const driverId = this.data.userprofileid;
    if (driverId) {
      this._loading.show();
      this.subscriptions.push(
        this.service.reactivateAccount(driverId)
          .finally(() => {
            this._loading.hiden();
            this.disbaledBtnSave = false;
          })
          .subscribe({
            next: (res) => {
              if (res) {
                this.sendNotify(res);
                this.getDataDriver();
                this.sweetAlertHelper.createCustomAlert({
                  type: 'success',
                  title: 'Mobile Account Reactivated',
                  text: 'The mobile account has been reactivated successfully. The driver can now log in to the app.',
                });
              }
            },
            error: (er) => {
              this.sendNotify(er);
            }
          })
      );
    }
  }

  get showBarcodeScannerComponent(): boolean {
    return this.driverLicenseScanner.isOpen;
  }

  get licenseStatusText(): string {
    if (this.data && this.data.driverlicensestatus && this.data.driverlicensestatus.description) {
      return this.data.driverlicensestatus.description;
    }
    return 'There is no information';
  }

  get licenseStatusClass(): string {
    const status = this.data && this.data.driverlicensestatus;

    if (!status) {
      return 'text-black';
    }

    return status.isvalid ? 'text-green' : 'text-red';
  }

  get showVerifyLicenseBtn(): boolean {
    return this.actionsComponent.verifyDriverLicense;
  }

  get showScanLicenseBtn(): boolean {
    return this.actionsComponent.scanDriverLicense;
  }

  get isNoteEmpty(): boolean {
    return !this.note || this.note.trim() === '';
  }

  private changeStatusFromSuspendedToApproved(): boolean {
    return this.previousStatus === OnDemandApplicationDriverStatusEnum.Suspended &&
      this.data.applicationstatusid === OnDemandApplicationDriverStatusEnum.Approved;
  }

  ngOnDestroy(): void {
    this.subscriptions.map((subscribe: Subscription) => subscribe.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/on-demand-drivers/components/personal-info/personal-info.component.ts